import React from 'react'
import { useParams } from 'react-router'
import { rejectContactInfoChange } from 'selfServicePortal/services/CustomerServices/updateUserService'
import { CircleSpinner } from 'shared'
import HeaderApplicationPage from '../Applications/HeaderApplicationPage/HeaderApplicationPage'
import './revokeContactChange.scss'
import { Footer, Heading } from 'selfServicePortal/components'
import { useQuery } from '@tanstack/react-query'

import { ReactComponent as Error } from '../../../img/icons/error.svg'
import { ReactComponent as Success } from '../../../img/icons/Done Icon Large.svg'
import { isAxiosError } from 'selfServicePortal/utils'

export default function RevokeContactChange() {
	let { id } = useParams()
	const rejectContactInfoChangeQuery = useQuery({
		queryKey: ['reject-contact-info-change', id],
		queryFn: () => rejectContactInfoChange(id!),
		enabled: Boolean(id),
	})

	const isNotFound = isAxiosError(rejectContactInfoChangeQuery.error)
		? rejectContactInfoChangeQuery?.error?.response?.status === 404
		: false

	return (
		<div className="revoke-contact-change">
			<HeaderApplicationPage isLogoutButtonShown={false} />

			<div className="content">
				<div className="container info-change-content">
					{rejectContactInfoChangeQuery.isLoading && (
						<CircleSpinner />
					)}

					{rejectContactInfoChangeQuery.isSuccess && (
						<>
							<Heading
								title={'Success Title'}
								description={'Success Description'}
							/>
							<Success width={120} height={120} />
						</>
					)}
					{rejectContactInfoChangeQuery.isError && (
						<>
							<Heading
								title={
									isNotFound
										? 'Code not found Error Title'
										: 'Error Title'
								}
								description={
									isNotFound
										? 'Code Not Found Error Description'
										: 'Error Description'
								}
							/>
							<Error width={120} height={120} />
						</>
					)}
				</div>
			</div>
			<Footer />
		</div>
	)
}
